<template>
  <div class="live-room">
    <!-- 左侧主区域 -->
    <div class="main-area">
      <!-- 顶部主播信息 -->
      <div class="header">
        <div class="anchor-info">
          <img :src="anchorInfo.avatar" class="anchor-avatar" alt="avatar" />
          <div class="anchor-detail">
            <span class="anchor-name">{{ anchorInfo.name }}</span>
            <button class="follow-btn" :class="{ followed: isFollowed }" @click="toggleFollow">
              {{ isFollowed ? '已关注' : '关注' }}
            </button>
          </div>
        </div>
        <div class="header-actions">
          <button class="close-btn" @click="closeRoom">
            <i class="el-icon-close"></i>
          </button>
        </div>
      </div>

      <!-- 播放器区域 -->
      <div class="player-section">
        <video class="prism-player"></video>
        <!-- 播放器遮罩控制层 -->
        <div class="player-overlay">
          <div class="overlay-top">
            <!-- 顶部可以添加其他信息 -->
          </div>
        </div>
      </div>

      <!-- 礼物区域 -->
      <div class="gift-section">
        <div class="gift-beijing">

        </div>
        <!-- 左箭头 -->
        <button v-if="showLeftArrow" class="scroll-arrow left" @click="scrollGiftList(-1)">
          <span class="arrow-icon">&#10094;</span>
          </button>
        <div ref="giftListRef" class="gift-list" @scroll="handleGiftScroll">
          <div v-for="(gift, index) in giftList" :key="index" :class="selectedGift === index?'gift-item2':'gift-item'" @click="selectGift(index)">
            <div class="gift-icon-wrap">
              <div class="gift-icon-rose"></div>
            </div>
            <div class="gift-name">{{ gift.name }}</div>
            <div class="gift-price">
              <i class="el-icon-coin"></i>
              <span>x{{ gift.price }}</span>
            </div>
            <button class="send-btn" @click.stop="sendGift(gift)">赠送</button>
          </div>
        </div>
        <!-- 右箭头 -->
        <button v-if="showRightArrow" class="scroll-arrow right" @click="scrollGiftList(1)">
          <span class="arrow-icon">&#10095;</span>
        </button>
        <div class="gift-balance" style="margin-bottom: 10px;">
          <img src="@/assets/tiantong.png" class="balance-icon" alt="甜筒" />
          <span class="balance-num">0</span>
        </div>
      </div>
    </div>

    <!-- 右侧边栏 -->
    <div class="sidebar">
      <!-- 观众列表 -->
      <div class="audience-section">
        <div class="section-title">
          <span>观众 · {{ audienceCount }}</span>
        </div>
        <div class="audience-list">
          <div v-for="(user, index) in audienceList" :key="index" class="audience-item">
            <img :src="user.avatar" class="audience-avatar" alt="avatar" />
            <span class="audience-name">{{ user.name }}</span>
            <span class="audience-score">贡献度{{ user.score }}</span>
          </div>
        </div>
      </div>

      <!-- 弹幕评论区 -->
      <div class="chat-section">
        <div class="chat-messages" ref="chatContainer">
          <div v-for="(msg, index) in chatMessages" :key="index" class="chat-item" :class="msg.type">
            <img v-if="msg.avatar" :src="msg.avatar" class="chat-avatar" alt="avatar" />
            <div class="chat-content">
              <span v-if="msg.name" class="chat-name">{{ msg.name }}</span>
              <span class="chat-text">{{ msg.text }}</span>
              <span v-if="msg.emoji" class="chat-emoji">{{ msg.emoji }}</span>
            </div>
          </div>
        </div>
      </div>

      <!-- 底部输入区 -->
      <div class="chat-input-section">
        <div class="notice-text">
          欢迎使用甜筒星球直播！你可以与其他用户实时互动、享受直播的乐趣。创作者必须年满18周岁才能开启直播。观众必须年满18周岁才能充值和赠送礼物。请务必遵守《社区自律公约》。
        </div>
        <div class="join-notice">
          <span>{{ latestJoin }} 已加入</span>
          <div class="emoji-list">
            <span v-for="(emoji, idx) in recentEmojis" :key="idx">{{ emoji }}</span>
          </div>
        </div>
        <div class="input-area">
          <input v-model="chatInput" type="text" placeholder="说点什么..." @keyup.enter="sendMessage" />
          <button class="emoji-btn" @click="toggleEmojiPicker">
            <i class="el-icon-sunny"></i>
          </button>
          <button class="like-btn" @click="sendLike">
            <i class="el-icon-star-off"></i>
          </button>
        </div>
      </div>
    </div>

    <!-- 礼物动画面层 -->
    <div v-if="showGiftAnimation" class="gift-animation">
      <div class="gift-effect">🎁 {{ currentGift.name }} x{{ currentGift.count }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LiveRoom',
  data() {
    return {
      // 播放器实例
      player: null,
      // 直播地址
      liveSrc: 'artc://bo.xiangyouhulian.cn/streanm/streanm16?auth_key=1786872852-0-0-4bf6f6364a270c3799af706b5153cca6',
      // 主播信息
      anchorInfo: {
        name: '甜甜音悦台',
        avatar: 'https://via.placeholder.com/40'
      },
      // 关注状态
      isFollowed: false,
      // 静音状态
      isMuted: false,
      // 观众数量
      audienceCount: 23,
      // 观众列表
      audienceList: [
        { name: '甜甜', avatar: 'https://via.placeholder.com/30', score: 20 },
        { name: 'mo mo', avatar: 'https://via.placeholder.com/30', score: 20 },
        { name: 'nano', avatar: 'https://via.placeholder.com/30', score: 20 }
      ],
      // 弹幕消息
      chatMessages: [
        { type: 'normal', name: '甜甜', text: '好好听呀！', emoji: '😍', avatar: 'https://via.placeholder.com/24' },
        { type: 'normal', name: 'mo mo', text: '厉害厉害', avatar: 'https://via.placeholder.com/24' },
        { type: 'normal', name: 'mo mo', text: '很专业', avatar: 'https://via.placeholder.com/24' }
      ],
      // 聊天输入
      chatInput: '',
      // 最新加入用户
      latestJoin: 'momo',
      // 最近表情
      recentEmojis: ['🎉', '👍', '😂', '❤️'],
      // 礼物列表
      giftList: [
        { iconClass: 'gift-icon-rose', name: '玫瑰', price: 1 },
        { iconClass: 'gift-icon-rose', name: '玫瑰', price: 1 },
        { iconClass: 'gift-icon-rose', name: '玫瑰', price: 1 },
        { iconClass: 'gift-icon-rose', name: '玫瑰', price: 1 },
        { iconClass: 'gift-icon-rose', name: '玫瑰', price: 1 },
        { iconClass: 'gift-icon-rose', name: '玫瑰', price: 1 },
        { iconClass: 'gift-icon-rose', name: '玫瑰', price: 1 },
        { iconClass: 'gift-icon-rose', name: '玫瑰', price: 1 },
        { iconClass: 'gift-icon-rose', name: '玫瑰', price: 1 },
        { iconClass: 'gift-icon-rose', name: '玫瑰', price: 1 },
        { iconClass: 'gift-icon-rose', name: '玫瑰', price: 1 },
        { iconClass: 'gift-icon-rose', name: '玫瑰', price: 1 },
        { iconClass: 'gift-icon-rose', name: '玫瑰', price: 1 },
        { iconClass: 'gift-icon-rose', name: '玫瑰', price: 1 },
        { iconClass: 'gift-icon-rose', name: '玫瑰', price: 1 },
      ],
      // 选中礼物
      selectedGift: 0,
      // 用户余额
      userBalance: 0,
      // 礼物动画显示
      showGiftAnimation: false,
      // 当前礼物
      currentGift: { name: '', count: 1 },
      // 是否显示左箭头
      showLeftArrow: false,
      // 是否显示右箭头
      showRightArrow: true
    }
  },
  mounted() {
  },
  methods: {
    // 充值 - 打开充值弹窗
    recharge() {
      this.$store.commit('setVipshow', true)
    },
    // 关注/取消关注
    toggleFollow() {
      this.isFollowed = !this.isFollowed
    },
    // 关闭直播间
    closeRoom() {
      this.$router.back()
    },
    // 选择礼物
    selectGift(index) {
      this.selectedGift = index
    },
    // 显示更多礼物
    showMoreGifts() {
      // TODO: 显示更多礼物弹窗
      console.log('显示更多礼物')
    },
    // 发送礼物
    sendGift(gift) {
      // TODO: 发送礼物逻辑
      console.log('发送礼物:', gift)
    },
    // 切换表情选择器
    toggleEmojiPicker() {
      // TODO: 显示表情选择器
      console.log('切换表情选择器')
    },
    // 发送点赞
    sendLike() {
      // TODO: 发送点赞
      console.log('发送点赞')
    },
    // 发送消息
    sendMessage() {
      if (this.chatInput.trim()) {
        this.chatMessages.push({
          type: 'normal',
          name: '我',
          text: this.chatInput,
          avatar: 'https://via.placeholder.com/24'
        })
        this.chatInput = ''
      }
    },
    // 滚动礼物列表
    scrollGiftList(direction) {
      const list = this.$refs.giftListRef
      if (!list) return
      const scrollAmount = 200 // 每次滚动距离
      list.scrollBy({
        left: direction * scrollAmount,
        behavior: 'smooth'
      })
    },
    // 处理礼物列表滚动事件
    handleGiftScroll() {
      const list = this.$refs.giftListRef
      if (!list) return
      // 判断是否显示左箭头
      this.showLeftArrow = list.scrollLeft > 0
      // 判断是否显示右箭头
      this.showRightArrow = list.scrollLeft < list.scrollWidth - list.clientWidth - 5
    }
  }
}
</script>

<style scoped lang="scss">
// 直播间主容器
.live-room {
  display: flex;
  width: 100%;
  height: 100vh;
  background: linear-gradient(135deg, #ffffff 0%, #ffffff 100%);
  overflow: hidden;
}

// 左侧主区域
.main-area {
  flex: 1;
  display: flex;
  flex-direction: column;
  padding: 16px;
  padding-right: 307px; // 给右侧边栏留空间 (280px + 16px padding)
  min-width: 0;
  background-color: #F5F3FA;
}

// 顶部头部
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
  padding: 8px 16px;
  background: rgba(255, 255, 255, 0.6);
  border-radius: 24px;
  backdrop-filter: blur(10px);
}

// 主播信息
.anchor-info {
  display: flex;
  align-items: center;
  gap: 12px;
}

.anchor-avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  object-fit: cover;
  border: 2px solid #fff;
}

.anchor-detail {
  display: flex;
  align-items: center;
  gap: 12px;
}

.anchor-name {
  font-size: 14px;
  font-weight: 500;
  color: #333;
}

.follow-btn {
  padding: 6px 16px;
  background: linear-gradient(135deg, #ff6b9d 0%, #ff8fb0 100%);
  border: none;
  border-radius: 16px;
  color: #fff;
  font-size: 12px;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    opacity: 0.9;
  }

  &.followed {
    background: #ccc;
  }
}

// 头部操作
.header-actions {
  display: flex;
  align-items: center;
  gap: 8px;
}

.close-btn {
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.8);
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  cursor: pointer;
  color: #666;
  transition: all 0.3s ease;

  &:hover {
    background: #fff;
    color: #333;
  }
}

// 播放器区域
.player-section {
  position: relative;
  flex: 1;
  border-radius: 16px;
  overflow: hidden;
  background: #000;
  margin-bottom: 12px;

  // 播放器容器
  .prism-player {
    width: 100%;
    height: 100%;
  }
}

// 播放器遮罩层
.player-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 16px;
  pointer-events: none;
  z-index: 10;
}

.overlay-top {
  pointer-events: auto;
}

.overlay-center {
  position: absolute;
  top: 50%;
  left: 0;
  right: 0;
  transform: translateY(-50%);
  display: flex;
  justify-content: space-between;
  padding: 0 16px;
  pointer-events: auto;
}

.nav-btn {
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.2);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.3);
  border-radius: 50%;
  color: #fff;
  font-size: 16px;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    background: rgba(255, 255, 255, 0.4);
  }
}

.overlay-bottom {
  pointer-events: auto;
}

.player-controls {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.control-btn {
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.2);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.3);
  border-radius: 8px;
  color: #fff;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    background: rgba(255, 255, 255, 0.4);
  }
}

.control-right {
  display: flex;
  gap: 8px;
}

// 礼物区域
.gift-section {
  display: flex;
  align-items: flex-end;
  padding: 0px 20px;
  height: 130px;
  gap: 12px;
  position: relative;
  overflow: visible;
  margin-top: 20px;
}
.gift-beijing{
  width: 100%;
  height: 100px;
  position: absolute;
  bottom: 0;
  left: 0;
  border-radius: 8px;
  background: #D9D5E5;
}
.gift-list {
  display: flex;
  align-items: center;
  gap: 8px;
  flex: 1;
  scrollbar-width: none;
  -ms-overflow-style: none;
  overflow-y: auto;
  &::-webkit-scrollbar {
    display: none;
  }
}
.gift-item2{
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 5px 14px;
  border-radius: 12px;
  cursor: pointer;
  // transition: all 0.3s ease;
  min-width: 60px;
  position: relative;
  flex-shrink: 0;
  margin-bottom: 10px;
  background: rgba(255, 255, 255, 0.3);
    backdrop-filter: blur(10px);
    box-shadow: 0 8px 20px rgba(155, 126, 217, 0.25);
    border-radius: 14px;
    z-index: 10;
    .send-btn {
      display: block;
    }
}
.gift-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 5px 14px;
  border-radius: 12px;
  cursor: pointer;
  min-width: 60px;
  position: relative;
  flex-shrink: 0;
  margin-top: 16px;
  &:hover {
    background: rgba(255, 255, 255, 0.3);
  }

  &.more {
    background: transparent;
    border: 1px dashed #9B8DC7;
    padding: 10px 12px;
    justify-content: center;
    min-height: 65px;

    &:hover {
      background: rgba(255, 255, 255, 0.3);
    }
  }
}

.gift-icon-wrap {
  margin-bottom: 4px;
}

.gift-icon-rose {
  width: 24px;
  height: 24px;
  position: relative;

  &::before {
    content: '';
    position: absolute;
    top: 3px;
    left: 50%;
    transform: translateX(-50%);
    width: 16px;
    height: 16px;
    background: radial-gradient(circle at 30% 30%, #FF6B9D, #FF8FB0);
    border-radius: 50%;
    box-shadow: 0 0 6px rgba(255, 107, 157, 0.4);
  }

  &::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    width: 3px;
    height: 8px;
    background: linear-gradient(to bottom, #50C878, #7EDDD7);
    border-radius: 2px;
  }
}

.gift-name {
  font-size: 12px;
  color: #4B3B73;
  margin-bottom: 2px;
}

.gift-price {
  display: flex;
  align-items: center;
  gap: 2px;
  font-size: 10px;
  color: #9B8DC7;

  i {
    font-size: 9px;
    color: #E6A23C;
  }
}

.send-btn {
  display: none;
  margin-top: 6px;
  padding: 4px 16px;
  background: #9B7ED9;
  color: #fff;
  font-size: 12px;
  font-weight: 500;
  border: none;
  border-radius: 12px;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background: #8B5CF6;
  }
}

.more-box {
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px dashed #9B8DC7;
  border-radius: 4px;
  margin-bottom: 4px;

  i {
    font-size: 12px;
    color: #7B5FB9;
  }
}

.gift-balance {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 2px;
  padding: 19px 10px;
  background: rgba(255, 255, 255, 0.5);
  border-radius: 10px;
  min-width: 50px;
  flex-shrink: 0;
  position: relative;
  .balance-icon {
    width: 22px;
    height: 22px;
    object-fit: contain;
  }

  .balance-num {
    font-size: 12px;
    color: #4B3B73;
  }
}

// 礼物列表滚动箭头
.scroll-arrow {
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #9B7ED9 0%, #7B5FB9 100%);
  border: none;
  border-radius: 50%;
  color: #fff;
  font-size: 16px;
  cursor: pointer;
  transition: all 0.3s ease;
  flex-shrink: 0;
  box-shadow: 0 4px 12px rgba(155, 126, 217, 0.4);
  z-index: 20;
  align-self: center; // 垂直居中
  margin-bottom: -30px; // 与礼物项底部对齐

  .arrow-icon {
    font-size: 14px;
    font-weight: bold;
    line-height: 1;
  }

  &:hover {
    transform: scale(1.1);
    box-shadow: 0 6px 16px rgba(155, 126, 217, 0.5);
  }

  &:active {
    transform: scale(0.95);
  }

  &.left {
    margin-right: 8px;
  }

  &.right {
    margin-left: 8px;
  }
}

// 右侧边栏
.sidebar {
  width: 260px;
  display: flex;
  flex-direction: column;
  padding: 16px;
  background: #F3EFFF;
  border-left: 1px solid rgba(255, 255, 255, 0.5);
  height: 96vh;
  position: fixed;
  right: 0px;
  top: 2px;
  border-radius: 12px;
  overflow: hidden;
}

// 观众区域
.audience-section {
  margin-bottom: 16px;
}

.section-title {
  font-size: 14px;
  font-weight: 500;
  color: #333;
  margin-bottom: 12px;
}

.audience-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.audience-item {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px;
  background: rgba(255, 255, 255, 0.6);
  border-radius: 8px;
}

.audience-avatar {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  object-fit: cover;
}

.audience-name {
  flex: 1;
  font-size: 13px;
  color: #333;
}

.audience-score {
  font-size: 11px;
  color: #8a3ffc;
}

// 聊天区域
.chat-section {
  flex: 1;
  overflow: hidden;
  margin-bottom: 16px;
}

.chat-messages {
  height: 100%;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding-right: 4px;

  &::-webkit-scrollbar {
    width: 4px;
  }

  &::-webkit-scrollbar-thumb {
    background: rgba(0, 0, 0, 0.2);
    border-radius: 2px;
  }
}

.chat-item {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  padding: 8px;
  background: rgba(255, 255, 255, 0.6);
  border-radius: 8px;

  &.gift {
    background: linear-gradient(135deg, rgba(255, 215, 0, 0.2) 0%, rgba(255, 215, 0, 0.1) 100%);
  }

  &.like {
    background: linear-gradient(135deg, rgba(255, 107, 157, 0.2) 0%, rgba(255, 107, 157, 0.1) 100%);
  }
}

.chat-avatar {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  object-fit: cover;
  flex-shrink: 0;
}

.chat-content {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 4px;
  font-size: 13px;
  line-height: 1.4;
}

.chat-name {
  color: #8a3ffc;
  font-weight: 500;
}

.chat-text {
  color: #333;
}

.chat-emoji {
  font-size: 16px;
}

// 聊天输入区
.chat-input-section {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.notice-text {
  font-size: 11px;
  color: #999;
  line-height: 1.5;
  padding: 8px;
  background: rgba(255, 255, 255, 0.4);
  border-radius: 8px;
}

.join-notice {
  display: flex;
  flex-direction: column;
  gap: 4px;
  font-size: 12px;
  color: #666;

  span {
    color: #8a3ffc;
  }
}

.emoji-list {
  display: flex;
  gap: 4px;
  font-size: 16px;
}

.input-area {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  background: rgba(255, 255, 255, 0.8);
  border-radius: 24px;

  input {
    flex: 1;
    border: none;
    background: transparent;
    font-size: 13px;
    color: #333;
    outline: none;

    &::placeholder {
      color: #999;
    }
  }
}

.emoji-btn,
.like-btn {
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  border: none;
  border-radius: 50%;
  cursor: pointer;
  color: #999;
  font-size: 18px;
  transition: all 0.3s ease;

  &:hover {
    color: #ff6b9d;
    background: rgba(255, 107, 157, 0.1);
  }
}

.like-btn {
  color: #ff6b9d;

  &:hover {
    transform: scale(1.1);
  }
}

// 礼物动画
.gift-animation {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 1000;
  pointer-events: none;
}

.gift-effect {
  padding: 16px 32px;
  background: linear-gradient(135deg, rgba(255, 215, 0, 0.9) 0%, rgba(255, 165, 0, 0.9) 100%);
  border-radius: 24px;
  color: #fff;
  font-size: 18px;
  font-weight: 600;
  animation: giftPop 2s ease-out forwards;
  backdrop-filter: blur(10px);
}

@keyframes giftPop {
  0% {
    opacity: 0;
    transform: scale(0.5);
  }
  20% {
    opacity: 1;
    transform: scale(1.1);
  }
  80% {
    opacity: 1;
    transform: scale(1);
  }
  100% {
    opacity: 0;
    transform: scale(0.8);
  }
}
</style>
